import React from 'react';
import { Icon } from './Icon';

export const TrashCanIcon: Icon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9.316" height="10.646" viewBox="0 0 9.316 10.646" {...props}>
      <path id="trash" d="M8.983.665h-2.5l-.2-.389A.5.5,0,0,0,5.845,0H3.468a.493.493,0,0,0-.445.277l-.2.389H.333A.333.333,0,0,0,0,1v.665A.333.333,0,0,0,.333,2h8.65a.333.333,0,0,0,.333-.333V1A.333.333,0,0,0,8.983.665ZM1.106,9.711a1,1,0,0,0,1,.936H7.213a1,1,0,0,0,1-.936L8.65,2.661H.665Z" transform="translate(0 0)" fill="#0076ce"/>
    </svg>
  );
};

export default TrashCanIcon;